import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface KpiTileProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  className?: string;
  /** e.g. "text-ok" for the mockup's positive-value tint. */
  valueClassName?: string;
  /** Makes the complete tile an accessible action, e.g. opening an audit trail. */
  onClick?: () => void;
}

export function KpiTile({ label, value, sub, className, valueClassName, onClick }: KpiTileProps) {
  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          onClick();
        }
      }}
      className={cn(
        "border-wg-03 bg-wg-02 flex min-h-[104px] flex-col justify-between rounded-xl border px-[18px] py-4",
        onClick &&
          "hover:bg-wg-03 focus-visible:outline-jj-red cursor-pointer transition-colors focus-visible:outline-2",
        className,
      )}
    >
      <div className="text-wg-07 text-[10.5px] leading-[1.35] font-semibold tracking-[0.13em] uppercase">
        {label}
      </div>
      <div>
        <div
          className={cn(
            "font-heading mt-2 text-[32px] font-medium tracking-[-0.02em]",
            valueClassName,
          )}
        >
          {value}
        </div>
        {sub != null && <div className="text-wg-07 text-[12.5px]">{sub}</div>}
      </div>
    </div>
  );
}
